import { StanCard, StanLineChart } from '@/components';
import { CourseMetricsSectionProps } from '../../types/courseAnalytics.types';
import { CourseMetricsCards } from './CourseMetricsCards';
import { useMemo } from 'react';

export function CourseMetricsSection({ analytics }: CourseMetricsSectionProps) {
    const metrics = {
        totalEnrollment: analytics.total_enrollment,
        overallCompletionRate: analytics.overall_completion_rate,
        totalLessonsCompleted: analytics.total_lessons_completed,
    };
    const series = useMemo(
        () => [
            {
                name: 'Lesson Completion',
                data: analytics.lessons_completion_rate,
                color: 'var(--color-seafoam-main)',
            },
        ],
        [analytics]
    );

    const customOptions = useMemo(
        () => ({
            xaxis: {
                labels: {
                    style: {
                        colors: 'var(--text-color-dark)',
                    },
                },
                group: {
                    style: {
                        fontSize: '10px',
                        fontWeight: 700,
                    },
                    groups: analytics.module_names.map((moduleName, index) => ({
                        title: moduleName,
                        cols: analytics.module_grouping_length[index] || 0,
                    })),
                },
            },
        }),
        [analytics]
    );
    return (
        <StanCard>
            <h3 className='text-dark'>Metrics</h3>
            <div className='flex w-full flex-col md:flex-row'>
                <CourseMetricsCards metrics={metrics} />
                <div className='flex flex-1 flex-col'>
                    <StanLineChart
                        type='line'
                        series={series}
                        categories={analytics.lessons_names}
                        yAxisMin={0}
                        yAxisMax={100}
                        tooltipFormatter={val => `${val}%`}
                        customOptions={customOptions}
                        height={360}
                        label='Retention'
                    />
                </div>
            </div>
        </StanCard>
    );
}
